import { MainStoreState } from 'modules/main/store/MainStoreState';
import { MainStoreContentsState } from 'modules/main/store/ducks/contents';

type Args = {
  state: Partial<MainStoreState> | undefined;
  url: string;
};

export function ssrGetComponentContent({ state, url }: Args) {
  const slug = url.substring(1, url.length).split('?')[0].replace(/\/$/, '');

  return (state?.contents as MainStoreContentsState | undefined)?.byUrl?.[slug];
}
